import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { Dotdotdot } from '@design-system/dotdotdot';
import { useI18n } from '@design-system/i18n';
import { UsersAvatarList } from '@design-system/users-avatar-list';
import { Cover } from './Cover';
import { GroupAndContentType } from './GroupAndContentType';
import { LinkWrapper } from './LinkWrapper';
import { CONTENT_LIST_SIZES } from '../constants';
import { getGroupPresentationImageWrapperSizes } from '../utils';
const DEFAULT_DISPLAY_FIELDS = {
    contentType: false,
    avatars: false,
    location: false,
    members: false,
};
const InfoLine = ({ displayFields = DEFAULT_DISPLAY_FIELDS, location, membersLabel, size, }) => {
    const canDisplayTotalMembers = displayFields.members && !displayFields.avatars;
    const canDisplayLocation = Boolean(displayFields.location && location);
    if (size === CONTENT_LIST_SIZES.SMALL &&
        (canDisplayTotalMembers || canDisplayLocation)) {
        return (_jsxs(Box, { flexDirection: "column", mt: 1, children: [canDisplayLocation && _jsx(Box, { children: location }), canDisplayTotalMembers && (_jsx(Box, { font: "body-semibold-asphalt", mt: canDisplayLocation ? 1 : 0, children: membersLabel }))] }));
    }
    if (canDisplayTotalMembers || canDisplayLocation) {
        const displaySeparationDot = membersLabel && canDisplayTotalMembers && canDisplayLocation;
        return (_jsxs(Box, { display: "block", mt: 1, children: [_jsx("span", { children: canDisplayTotalMembers ? membersLabel : null }), displaySeparationDot && _jsx("span", { children: "\u00A0\u00B7\u00A0" }), _jsx("span", { children: canDisplayLocation ? location : null })] }));
    }
    return null;
};
export const GroupPresentation = ({ contentTypeName, data: { image, location, members, membersLabel, name, seeMoreOnClick, totalMembers, }, displayFields = DEFAULT_DISPLAY_FIELDS, onClick, path, size, withLink, }) => {
    const { __ } = useI18n();
    const groupMembers = members
        ? members === null || members === void 0 ? void 0 : members.map((user, index) => {
            var _a;
            return ({
                id: (_a = user.id) !== null && _a !== void 0 ? _a : index,
                name: user.name,
                photo_thumb_url: user.photo_thumb_url,
            });
        })
        : [];
    return (_jsxs(Box, { flexDirection: { _: 'column', m: 'row' }, width: "100%", children: [_jsx(ImageWrapper, { "$size": size, children: _jsx(Cover, { fallbackIconName: "user-group", imageSrc: image, onClick: onClick, path: path, size: size, withLink: withLink }) }), _jsxs(Box, { flexDirection: "column", justifyContent: "center", maxWidth: { _: '100%', m: '60%' }, children: [displayFields.contentType && (_jsx(GroupAndContentType, { type: displayFields.contentType
                            ? contentTypeName !== null && contentTypeName !== void 0 ? contentTypeName : __('Group')
                            : undefined })), _jsx(Box, { children: _jsx(LinkWrapper, { font: "h4-semibold", onClick: onClick, path: path, withLink: withLink, children: _jsx(Dotdotdot, { clamp: 2, children: name }) }) }), _jsx(InfoLine, { displayFields: displayFields, location: location, membersLabel: membersLabel, size: size }), displayFields.avatars && members && (_jsx(Box, { mt: size === CONTENT_LIST_SIZES.SMALL ? 1 : 2, children: _jsx(UsersAvatarList, { maxAvatars: 3, onClickMore: seeMoreOnClick, totalUsers: totalMembers, users: groupMembers }) }))] })] }));
};
const ImageWrapper = styled(Box).attrs(({ $size }) => {
    const sizes = getGroupPresentationImageWrapperSizes($size);
    return {
        alignSelf: 'flex-start',
        maxWidth: sizes.maxWidth,
        minWidth: sizes.minWidth,
        mr: sizes.mr,
        mb: { _: 3, m: 0 },
        flexShrink: 0,
    };
}) `
  aspect-ratio: 757/418;
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  overflow: hidden;
`;
//# sourceMappingURL=GroupPresentation.js.map